import { onlyNumbers, validateCPF } from '@/shared/validation/index'
import { z } from 'zod'

export const pidDataFormSchema = z.object({
  cpf: z
    .string()
    .min(14, { message: 'CPF deve ter 11 dígitos' })
    .max(14, { message: 'CPF deve ter 11 dígitos' })
    .transform((cpf) => onlyNumbers(cpf))
    .refine((cpf) => validateCPF(cpf), { message: 'Informe um CPF válido' }),
  ticket: z
    .string()
    .min(5, { message: 'Informe um ticket válido' })
    .max(20, { message: 'Informe um ticket válido' })
    .regex(/^[a-zA-Z0-9-]+$/, {
      message: 'O ticket deve conter apenas letras, números e hífens',
    }),
})

export type PIDFormData = z.infer<typeof pidDataFormSchema>
